'use strict';

var $ = require('../internals/export');

var $trim = require('../internals/string-trim').trim;

var forcedStringTrimMethod = require('../internals/forced-string-trim-method'); // `String.prototype.trim` method
// https://tc39.github.io/ecma262/#sec-string.prototype.trim


$({
  target: 'String',
  proto: true,
  forced: forcedStringTrimMethod('trim')
}, {
  trim: function trim() {
    return $trim(this);
  }
});